export default {
  name: 'CategorySeo',
  props: {
    metaTitle: {
      type: String,
      required: true
    },
    metaDescription: {
      type: String,
      required: true
    }
  },

  head() {
    return {
      title: "".concat(this.metaTitle, " | Maisons du Monde"),
      meta: [{
        charset: 'utf-8'
      }, {
        name: 'description',
        content: this.metaDescription
      }]
    };
  },

  render: h => h(null)
};